<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <!-- [ページタイトル] -->
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'label.planList.title' | staticMsg"></h1>
        </div>
        <!-- [//ページタイトル] -->

        <!-- [他端末引継ぎボタン] -->
        <div *ngIf="isPlanZero" class="l-top-navi__function-area">
          <div class="l-top-navi__function-item">
            <button id="planList-sub-header-share-button" aswThrottleClick (throttleClick$)="mergePlanList()">
              <img src="assets/images/icon_share_primary_24.svg" width="24" height="24" alt="share" />
            </button>
          </div>
        </div>
        <!-- [//他端末引継ぎボタン] -->
      </div>
    </div>
  </div>
</div>
